export const SliderData = [
  {
    image: require("./images/IMG_Panel.jpeg"),
  },
  {
    image: require("./images/IMG_Bina.jpeg"),
  },
];
